import style from '../RefreshIndicator/RefreshIndicator.css';

export default function RefreshIndicator({
  className = '',
  height,
  refreshing,
  threshold = 50,
}) {
  return (
    <div
      className={style.refresh}
      style={{
        height: `${height}px`,
        marginTop: refreshing || height > 0 ? `${threshold}px` : '0px',
      }}
    >
      {refreshing && <div className={style.loading}></div>}
    </div>
  );
}
